import InstantPaymethods from "components/Tutorials/InstantPayTutorial.tsx/InstantPaymethods";
import React from "react";

interface ISetupPaymentmethodProps {
  setLastCompletedStep: (id: number) => void;
}

const SetupPaymentmethod: React.FC<ISetupPaymentmethodProps> = ({
  setLastCompletedStep,
}) => {
  return (
    <div className="w-full">
      <InstantPaymethods setLastCompletedStep={setLastCompletedStep} />
    </div>
  );
};

export default SetupPaymentmethod;
